<template>
    <v-container class="d-flex">
                <v-card class="mt-40 v-card-width" elevation="0">
                    <!-- <img class = "back_image" src = "/img/arrow_back.svg" @click="goBack"/> -->
                    <editProfileDialog
                        v-if="showEditProfileDialog"
                        :showEditProfileDialog="showEditProfileDialog"
                        @closeDialog="closeEditProfileDialog"
                        />
                        <editPhoneDialog
                            v-if="showEditPhoneDialog"
                            :showEditPhoneDialog="showEditPhoneDialog"
                            @closeDialog="closeEditPhoneDialog"
                        />
                        <editBankDialog
                            v-if="showEditBankDialog"
                            :showEditBankDialog="showEditBankDialog"
                            @closeDialog="closeEditBankDialog"
                        />
                        <editEmailDialog
                            v-if="showEditEmailDialog"
                            :showEditEmailDialog="showEditEmailDialog"
                            @closeDialog="closeEditEmailDialog"
                        />
                    <!-- <v-row>
                        <v-col>
                            <h5 style="font-size:22px">Settings</h5>
                        </v-col>
                    </v-row> -->
                    <v-row class="textContainer py-8">
                        <v-col class="pl-8 heading">
                            Name (as on PAN Card)
                        </v-col>
                        <v-col align="right" class="pr-8 text d-flex" id="settings">
                            {{ userName }}
                        <v-icon class = "lockIcon materials-icon-round">lock</v-icon>
                        </v-col>
                    </v-row>
                    <hr />
                    <v-row class="textContainer py-8">
                        <v-col class="pl-8 heading">
                            Photo
                        </v-col>
                        <v-col align="right">
                            <figure class="profileImage d-flex" id="settings">
                                <img v-if="profileImage" :src="profileImage" alt="" />
                                <span class="initials" v-else>{{
                                    userName | formatName()
                                }}</span>
                                <p class = "editText" @click="editProfileImage">Edit</p>
                            </figure>
                        </v-col>
                    </v-row>
                    <hr />
                    <v-row class="textContainer py-8">
                        <v-col class="pl-8 heading">
                            Email
                        </v-col>
                        <v-col align="right" class="pr-8 text d-flex" id="settings">
                            {{ email }}
                            <p class = "editText" @click="editEmail">Edit</p>
                        </v-col>
                    </v-row>
                    <hr />
                    <v-row class="textContainer py-8">
                        <v-col class="pl-8 heading">
                            Mobile Number
                        </v-col>
                        <v-col align="right" class="pr-8 text d-flex" id="settings">
                            {{ phoneNo }}
                            <p class = "editText" @click="editPhoneNo">Edit</p>
                        </v-col>
                    </v-row>
                    <hr />
                    <p v-if = "accountStatus === 'FROZEN' " class = "frozenText">Your Account has been frozen! Please contact customer support</p>
                    <div v-else class="pt-60">
                        <button class="leftAlign withdrawButton" @click="withdrawPortfolio">
                            Withdraw
                            <v-icon class="font-size-18">fas fa-chevron-right</v-icon>
                        </button>
                    </div>
                </v-card>
    </v-container>
</template>

<script>
import editProfileDialog from '@/components/common/editProfile/editProfileDialog.vue'
import editPhoneDialog from '@/components/common/editProfile/editPhoneDialog.vue'
import editBankDialog from '@/components/common/editProfile/editBankDialog.vue'
import editEmailDialog from '@/components/common/editProfile/editEmailDialog.vue'
export default {
    name: 'Settings',
    components: {
        editProfileDialog,
        editPhoneDialog,
        editBankDialog,
        editEmailDialog
    },
    data () {
        return {
            userName: null,
            email: '',
            phoneNo: '',
            profileImage: '',
            bankAccountNumber: '',
            bankIfsc: '',
            showEditProfileDialog: false,
            showEditPhoneDialog: false,
            showEditBankDialog: false,
            showEditEmailDialog: false,
            accountStatus: null,
            tab: 0,
            items: ['Account Details', 'Virtual Account']
        }
    },
    watch: {
        '$store.state.dashboard.profileImage': {
            handler (newValue, oldValue) {
                this.profileImage = this.$store.state.dashboard.profileImage
            },
            deep: true,
            immediate: true
        }
    },
    filters: {
        formatName (string) {
            const names = string.split(' ')
            const initials = names[0].substring(0, 1).toUpperCase()
            return initials
        }
    },
    mounted () {
        this.accountStatus = this.$store.getters['dashboard/getAccountStatus']
        this.userName =
        this.$store.state.userName || this.$store.state.onBoarding.Name
        this.phoneNo = this.$store.state.dashboard.phoneNo
        this.email = this.$store.state.onBoarding.Email
        this.profileImage = this.$store.state.dashboard.profileImage
        this.bankAccountNumber = this.$store.state.dashboard.bankAccountNumber
        this.bankIfsc = this.$store.state.dashboard.bankIfsc
    },
    methods: {
        goBack () {
            this.$router.push('/dashboard')
        },
        refreshPage () {
            this.$router.go()
        },
        editProfileImage () {
            this.showEditProfileDialog = true
        },
        closeEditProfileDialog () {
            this.showEditProfileDialog = false
        },
        editPhoneNo () {
            this.showEditPhoneDialog = true
        },
        editEmail () {
            this.showEditEmailDialog = true
        },
        closeEditPhoneDialog () {
            this.showEditPhoneDialog = false
            this.refreshPage()
        },
        closeEditEmailDialog () {
            this.showEditEmailDialog = false
            this.refreshPage()
        },
        editBank () {
            this.showEditBankDialog = true
        },
        closeEditBankDialog () {
            this.showEditBankDialog = false
            this.refreshPage()
        },
        withdrawPortfolio () {
            this.$router.push({ path: '/portfolio/withdrawal' })
        }
    }
}
</script>
<style lang="scss" scoped>
@import "~@/sass/components/_dashboard-layout.scss";

.frozenText {
    text-align: center;
        color: red
    }
.back_image {
    cursor: pointer;
    margin-bottom: 50px
}
.v-card-width {
    flex: 1
}
.notifications {
    position: relative;
}

.icon {
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;
}
hr {
    height: 0px;
    border: 0.5px solid rgba(189, 189, 189, 0.3);
    opacity: 0.5;
}
.profileImage {
    position: relative;
    align-items: center;
    margin-right: 12px;
    img {
        width: 38px;
        height: 38px;
        border-radius: 50%;
    }
    justify-content: flex-end;
}
.initials {
    display: inline-block;
    background-color: #acbeff;
    border-radius: 50%;
    color: white;
    padding-top: 2px;
    width: 32px;
    height: 32px;
    margin-right: 16px;
    text-align: center;
    font-size: 18px;
    font-weight: normal;
}
.heading {
    font-weight: 500;
    font-size: 18px;
    color: #4f4f4f;
}
.text {
    position: relative;
    color: #4f4f4f;
    justify-content: flex-end;
}
.short-text{
    display: none;
}

.withdrawButton {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 11px 24px;
    gap: 10px;
    align-items: center;
    justify-content: space-between;
    border: 1.5px solid #002FA7;
    border-radius: 6px;
    color: #002FA7;
    letter-spacing: 0.005em;
    font-size: 14px;
    line-height: 150%;
    font-weight: 600;
}

.v-icon.v-icon.fa-chevron-right{
    color: #002FA7;
}
@media (max-width: 600px) {
    #settings {
        justify-content: flex-start;
    }
    .short-text{display: inline-block;}
    .container{
        justify-content: start !important;
    }
    .mt-60.v-card.v-sheet.theme--light.elevation-0{
        margin-top:10px !important;
    }
    .row{
        flex-direction: column;
        padding: 10px !important;
    }
    .v-card-width {
        width: 100% !important;
    }
    .lockIcon {
        font-size: 15px;
        padding-left: 20px;
        position: absolute;
        left: 80%
    }
    .editText {
        position: absolute;
        left: 82%;
        text-align: center;
        margin-bottom: 0px !important;
        text-decoration: underline;
        padding-left: 15px !important;
    }
}
    .lockIcon {
        font-size: 15px;
        padding-left: 15px
    }
    .textContainer {
        align-items: center
    }
    .editText {
        color: #007AFF;
        cursor: pointer;
        font-weight: 600;
        text-align: center;
        margin-bottom: 0px !important;
        text-decoration: underline;
        padding-left: 15px !important;
    }
</style>
